module.exports = __webpack_public_path__ + "static/media/smartAsn-logos-BRIN.6662eeb7.svg";